<div class="p-field p-col-12 p-md-4">
    <label for="icon">Icon</label>
    <p-datepicker [(ngModel)]="value" [showIcon]="true" inputId="icon" [readonlyInput]="true" [showButtonBar]="true" appendTo="body"></p-datepicker>
</div>
